import makeBasicTheme from '../makeBasicTheme'
const mainColor = "#c0c5ce"
export default makeBasicTheme(mainColor)